<template>
  <div class="activity">
    <Activity />
  </div>
</template>

<script>
// @ is an alias to /src
import Activity from "@/components/Activity.vue";

export default {
  name: "ActivityRoute",
  components: {
    Activity
  }
};
</script>
